import React from 'react';
import {NativeStackScreenProps} from '@react-navigation/native-stack';
import {StackParamList} from '../../navigators';
import {SuccessTemplate} from '../../components/templates/success';
import {PrimaryButton} from '../../components/buttons';
import {message} from '../../utils/messages';

type ScreenProps = NativeStackScreenProps<StackParamList, 'RequestSuccess'>;

export const RequestSuccessScreen = ({navigation}: ScreenProps) => {
  const handleOnOk = async () => {
    navigation.navigate('SignIn');
  };

  return (
    <SuccessTemplate
      title={message('request-success-title')}
      summary={message('request-success-summary')}>
      <PrimaryButton
        label={message('request-success-button')}
        onPress={() => handleOnOk()}
      />
    </SuccessTemplate>
  );
};
